import request from '@/utils/request'

// List package spot releases with filters
export function listPackageSpotReleases(params) {
  return request({
    url: '/parking/packageSpotRelease/user/list',
    method: 'get',
    params:params
  })
}

// Get package spot release detail
export function getPackageSpotRelease(id) {
  if (!id) {
    console.warn('getPackageSpotRelease called with null or undefined id');
    return Promise.reject(new Error('Package spot release ID is required'));
  }
  return request({
    url: `/parking/packageSpotRelease/user/detail/${id}`,
    method: 'get'
  })
}

// Get available package spots for a parking space
export function getPackageSpotsForParkingSpace(parkingSpaceId) {
  return request({
    url: '/parking/packageSpotRelease/byParkingSpace',
    method: 'get',
    params: { parkingSpaceId }
  })
}

// Get package spots by type (monthly, daily, etc.)
export function getPackageSpotsByType(type) {
  return request({
    url: '/parking/packageSpotRelease/byType',
    method: 'get',
    params: { type }
  })
}

// Get available inventory for a specific release
export function getAvailableInventory(releaseId) {
  return request({
    url: `/parking/packageSpotRelease/inventory/${releaseId}`,
    method: 'get'
  })
}

// Check inventory availability for a specific time period
export function checkInventoryAvailability(releaseId, startDate, endDate) {
  return request({
    url: '/parking/packageSpotRelease/checkInventory',
    method: 'get',
    params: {
      releaseId: releaseId,
      startDate: startDate,
      endDate: endDate
    }
  })
}
